import { createContext } from 'react'

export interface CartItem {
  id: string
  name: string
  price: number
  quantity: number
  image?: string
}

interface CartState {
  items: CartItem[]
  isOpen: boolean
}

interface CartActions {
  addItem: (item: CartItem) => void
  removeItem: (itemId: string) => void
  updateQuantity: (itemId: string, quantity: number) => void
  clearCart: () => void
  setIsOpen: (isOpen: boolean) => void
  toggleCart: () => void
}

interface CartCalculations {
  totalItems: number
  totalPrice: number
}

type CartContextType = CartState & CartActions & CartCalculations

export const CartContext = createContext<CartContextType | undefined>(undefined)
